import 'styles/pages/palantir.scss';
import '~scripts/main';
import runWithFPS from 'run-with-fps';
import initSparks from './sparks';

// Blocks
import Header from '~scripts/blocks/header';

//
// HEADER
//
Header();

initSparks(document.querySelector('.sparks'));

const promoText =
  'Вас ждет прекрасное будущее,<br />а закрывать вакансии в срок <a href="https://huntflow.ru/?utm_source=huntflow-palantir&utm_medium=link&utm_campaign=forecast" target="_blank">поможет&nbsp;Хантфлоу</a>!';

const PREDICTIONS = [
  ['Вас ждут тысячи', 'идеальных кандидатов'],
  ['Вы закроете все', 'незакрывающиеся вакансии'],
  ['Заказчик перестанет менять', 'требования к кандидатам'],
  ['Вас ждет незабываемый отпуск'],
  ['Примут все офферы, которые', 'вы сделаете в этом месяце'],
  ['В конце года вас ждет', 'награда за работу'],
  ['Сбудется все, что задумано'],
  ['Сейчас подходящее время,', 'чтобы отдохнуть'],
  ['Сегодня вы будете', 'наслаждаться удачей'],
  ['В конце недели будет', 'повод для бокала игристого'],
  ['Кандидаты будут отвечать', 'на каждое письмо и звонок'],
  ['Завтра вас ждет приятная встреча'],
];

const pHeader = document.querySelector('.prediction-header');
const ball = document.querySelector('.ball');
const ballBG = document.querySelector('.ball-bg');
const button = document.querySelector('.js-run');
const buttonPlace = document.querySelector('.button-place');

const img = ball.querySelector('img');

setTimeout(() => {
  ball.classList.add('g-shown');
}, 100);
setTimeout(() => {
  pHeader.classList.add('g-shown');
}, 1000);
setTimeout(() => {
  buttonPlace.classList.add('g-shown');
}, 1500);
let angle = 0;
runWithFPS(() => {
  angle += 0.19;
  img.style.transform = `rotate(${-angle}deg)`;
}, 14);

const result = document.querySelector('.result');
const prediction = result.querySelector('.prediction');
const share = result.querySelector('.share');
const promo = result.querySelector('.promo');
const showPrediction = () => {
  result.classList.add('g-shown');
  const predictionIndex = Math.round(Math.random() * (PREDICTIONS.length - 1));
  const predictionText = PREDICTIONS[predictionIndex];
  const text = prediction;
  requestAnimationFrame(() => {
    text.innerHTML = predictionText
      .map((line) =>
        line
          .split('')
          .map((c) => (c === ' ' ? c : `<span>${c}</span>`))
          .join('')
      )
      .map((line) => `<div class="line">${line}</div>`)
      .join('');
    [...text.querySelectorAll('span')].forEach((span, i, arr) => {
      span.style.animationDelay = `${0.9 * (i / arr.length)}s`;
    });
  });
  text.title = predictionText.join(' ');
  promo.innerHTML = promoText;

  share.querySelector('.likely').dataset.url = `${location.origin}${location.pathname}?p=${predictionIndex}`;
  if (window.likely) {
    window.likely.initate();
  }

  setTimeout(() => {
    requestAnimationFrame(() => {
      share.classList.add('g-shown');
    });
  }, 1300);
  setTimeout(() => {
    requestAnimationFrame(() => {
      promo.classList.add('g-shown');
    });
  }, 2000);
};

button.addEventListener('click', () => {
  ballBG.classList.remove('ball_rotate');
  ballBG.classList.add('ball_rotate');
  buttonPlace.classList.remove('g-shown');
  setTimeout(showPrediction, 1100);
});
